/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commerical BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2024-03-06 15:00:00
 *
 *******************************************************/
import _ from 'lodash';

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Card, Button } from '@shopify/polaris';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';
import { routes } from 'src/routes';

import history from 'src/routes/history';
import * as installActions from 'actions/install-actions';
import ButtonCustom from './button';

type Props = WithI18nProps;

class SuccessInstallScreen extends Component<Props> {
  constructor(props) {
    super(props);
    this.state = {
      features: [],
      industries: [],
      revenue: null
    };
  }

  componentDidMount() {
    const { kycData } = this.props;
    const features = _.get(kycData, 'features', []);
    const industries = _.get(kycData, 'industries', []);
    const revenue = _.get(kycData, 'revenue', null);

    this.setState({
      features,
      industries,
      revenue
    });
  }

  onSetStep = async (key, data) => {
    const { updateInstallationKYCStatus } = this.props;
    const formData = {
      [key]: data
    };
    updateInstallationKYCStatus(formData);
  };

  onChooseTheme = async () => {
    const { updateInstallationStatus } = this.props;
    updateInstallationStatus('submitted-kyc');
    history.push(routes.newInstallation.chooseTheme());
  };

  onSuccessInstall = async () => {
    const { updateInstallationStatus } = this.props;
    updateInstallationStatus('submitted-kyc');
    history.push(routes.newInstallation.successInstall());
  };

  onSubmitKYC = async (values, isNewUser = false) => {
    await this.onSetStep('features', values);
    if (isNewUser) {
      this.onSuccessInstall();
    } else {
      this.onChooseTheme();
    }
  };

  gotoDashboard = () => {
    const { updateInstallationStatus } = this.props;
    updateInstallationStatus('');
    history.push(routes.dashboard.view());
  };

  publishFeature = () => {
    const { updateInstallationStatus } = this.props;
    updateInstallationStatus('');
    history.push(routes.shopifyIntegration.view());
  };

  render() {
    const { i18n } = this.props;

    return (
      <div className="BC-AnotherLayout BC-page_Installation SuccessInstall">
        <Card>
          <div className="BC-page_Installation--SuccessInstall">
            <div className="wrapper">
              <div className="content">
                <div className="inner-content">
                  <div className="title">
                    {i18n.translate('AdminHTML.InstallationV2.SuccessInstall.title')}
                  </div>
                  <div className="description">
                    {i18n.translate('AdminHTML.InstallationV2.SuccessInstall.description')}
                  </div>
                  <div className="list">
                    <div className="item">
                      <div className="icon">
                        <img
                          src="/assets/images/installation/circle-check_spot.svg"
                          width={14}
                          height={14}
                          alt=""
                        />
                      </div>
                      <div className="item-content">
                        <div className="title2">
                          {i18n.translate('AdminHTML.InstallationV2.SuccessInstall.t1')}
                        </div>

                        <div className="description2">
                          {i18n.translate('AdminHTML.InstallationV2.SuccessInstall.d1')}
                        </div>
                      </div>
                    </div>
                    <div className="item">
                      <div className="icon">
                        <img
                          src="/assets/images/installation/circle-check_spot.svg"
                          width={14}
                          height={14}
                          alt=""
                        />
                      </div>
                      <div className="item-content">
                        <div className="title2">
                          {i18n.translate('AdminHTML.InstallationV2.SuccessInstall.t2')}
                        </div>

                        <div className="description2">
                          {i18n.translate('AdminHTML.InstallationV2.SuccessInstall.d2')}
                        </div>
                      </div>
                    </div>
                    <div className="item">
                      <div className="icon">
                        <img
                          src="/assets/images/installation/circle-check_spot.svg"
                          width={14}
                          height={14}
                          alt=""
                        />
                      </div>
                      <div className="item-content">
                        <div className="title2">
                          {i18n.translate('AdminHTML.InstallationV2.SuccessInstall.t3')}
                        </div>

                        <div className="description2">
                          {i18n.translate('AdminHTML.InstallationV2.SuccessInstall.d3')}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="action">
                    <Button onClick={this.gotoDashboard}>
                      {i18n.translate('AdminHTML.InstallationV2.SuccessInstall.btn1')}
                    </Button>
                    <ButtonCustom onClick={this.publishFeature}>
                      {i18n.translate('AdminHTML.InstallationV2.SuccessInstall.btn2')}
                    </ButtonCustom>
                  </div>
                </div>
              </div>
              <div className="preview">
                <img src="/assets/images/installation/success-install-2x.png" alt="" />
              </div>
            </div>
          </div>
        </Card>
      </div>
    );
  }
}

const mapStateToProps = (state, props) => {
  return {
    tenantApp: _.get(state.oauth, 'tenantApp', {}),
    loading: state.install.loading,
    success: state.install.success,
    error: state.install.error,
    KYCValue: state.install.KYCValue,
    installStatus: _.get(state, 'oauth.tenantApp.installStatus'),
    kycData: _.get(state, 'oauth.tenantApp.kycData')
  };
};

const mapDispatchToProps = (dispatch, ownProps) => ({
  addDemographic: body => dispatch(installActions.addDemographic(body)),
  updateInstallationStatus: status => dispatch(installActions.updateInstallationStatus(status)),
  updateInstallationKYCStatus: data => dispatch(installActions.updateInstallationKYCStatus(data))
});

export default withI18n()(connect(mapStateToProps, mapDispatchToProps)(SuccessInstallScreen));
